const filePreview = {
    namespaced: true,    
    state: {
        richEditState: false
    },
    mutations: {
        SET_RICHEDITSTATE(state, payload) {
            state.richEditState = payload;
        },
    },
    getters: {
        getRichEditState: s => s.richEditState,
    }
};

export default filePreview;